import styled from 'styled-components'
import { Button } from '@mui/material'
import config from 'config/config'

export const Spacing = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

export const MyhhsBlueBorderButton = styled(Button)`
  color: ${config.colors.darkblue} !important;
  text-transform: none !important;
  cursor: pointer !important;
  &:hover {
    color:  ${config.colors.white} !important;
    background-color: ${config.colors.darkblue} !important;
    border-color: ${config.colors.darkblue} !important;    
  }
`

export const MyhhsBlueButton = styled(Button)`
  background-color: ${config.colors.darkblue} !important;
  color: ${config.colors.white} !important;
  font-family: 'Source Sans Pro', sans-serif !important;
  text-transform: none !important;
  width: 100%;
  &:hover {
    background-color: ${config.colors.tangaroa} !important;
  }
`
export const MyhhsBlueButtonUC = styled(Button)`
  background-color: ${config.colors.darkblue} !important;
  color: ${config.colors.white} !important;
  font-family: 'Source Sans Pro', sans-serif !important;
  text-transform: uppercase !important;
  width: 100%;
  &:hover {
    background-color: ${config.colors.tangaroa} !important;
  }
`

export const MyhhsLightBlueButton = styled(Button)`
  background-color: ${config.colors.white} !important;
  color: ${config.colors.darkblue} !important;
  text-transform: none !important;
  width: 100%;
  border: 1px solid ${config.colors.blue} !important;
  box-shadow: none !important;
  &:hover {
    color: ${config.colors.white} !important;
    background-color: ${config.colors.blueprimary} !important;
    border-color: ${config.colors.blueprimary} !important;
  }
`

export const MyhhsOulinedBlue = styled(Button)`
  border: 1px solid ${config.colors.blueprimary} !important;
  text-transform: none !important;
  color: ${config.colors.blueprimary} !important;
  &:hover {
    background-color: ${config.colors.btnBlue} !important;
    color: ${config.colors.white} !important;
  }
}`

export const MyhhsButton = styled(Button)`
  background-color: ${config.colors.darkblue} !important;
  color: ${config.colors.white} !important;
  text-transform: none !important;
  width: 10rem;
  &:hover {
    background-color: ${config.colors.tangaroa} !important;
  }
`

export const MyhhsButtonForOutlineInput = styled(Button)`
  background-color: ${config.colors.darkblue} !important;
  color: ${config.colors.white} !important;
  text-transform: none !important;
  width: 10rem;
  border-radius: 0 4px 4px 0 !important;
  &:hover {
    background-color: ${config.colors.tangaroa} !important;
  }
`

export const MyhhsWhiteButton = styled(Button)`
  background-color: ${config.colors.white} !important;
  font-family: ${config.fontfamily} !important;
  color:rgb(0, 89, 116) !important;
  border-color: rgb(0, 89, 116) !important;
  text-transform: none !important; 
  width: 100%;
  &:hover {
    color: ${config.colors.white} !important;
    background-color: ${config.colors.btnBlue} !important;
  }
`
export const MyhhsTransparentButton = styled(Button)`
background-color: transparent !important;
font-family: ${config.fontfamily} !important;
color:rgb(0, 89, 116) !important;
border-color: rgb(0, 89, 116) !important;
text-transform: none !important; 
width: 100%;
&:hover {
  color: ${config.colors.white} !important;
  background-color: ${config.colors.btnBlue} !important;
}
`

export const MyhhsBlackButton = styled(Button)`
  background-color:${config.colors.black} !important;
  font-family: ${config.fontfamily} !important;
  color: ${config.colors.white} !important;
  border-radius: 0 !important;
  font-size: 14px !important;
  padding: 5px 15px !important;
  letter-spacing: 1.5px !important;
  line-height: 1.2;
  font-family: Helvetica,sans-serif !important;
`

export const MyhhsBlueButtonWidth = styled(Button)`
  background-color: ${config.colors.darkblue} !important;
  color: ${config.colors.white} !important;
  font-family: 'Source Sans Pro', sans-serif !important;
  text-transform: none !important;
  &:hover {
    background-color: ${config.colors.tangaroa} !important;
  }
`

export const MyhhsWrapper = styled.div`
  font-family: ${config.fontfamily};
`

export const Content = styled.div`
  width: 53.8rem;
  margin: ${config.margin};
  box-sizing: border-box;
`

export const MyhhsContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
`

export const MyhhsHeaderLabel = styled.h2`
  display: inline-block;
  font-size: ${config.font16};
  padding: 0 20px 0;
  line-height: ${config.height29};
  height: ${config.height29};
  margin: 0;
  font-weight: normal;
`

export const MyhhsHeader = styled.div`
  padding: 0;
`

export const MyhhsHeaderTable = styled.div`
  padding: 0 10px;
`
